
import { PORIFILES_API } from "../../../constants/api"
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GetPfofileById(id) {
    const api = `${PORIFILES_API}ordinary/${id}`;
    return axiosHttp.get(api);
}